import React from 'react';

const CustomTooltip = ({ title, content, x, y }) => {
    return (
        <div className='custom-tooltip' style={{ top: y, left: x }}>
            <h5 className='tooltip-title'>{title}</h5>
            <div className='tooltip-content' dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};

export default CustomTooltip;